import React from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import find from 'lodash/find';
import Content from 'components/Content';
import withContent from 'components/Content/withContent';
import Overview from './Overview';
import Environmental from './Environmental';
import Social from './Social';
import Governance from './Governance';

const CONTENT_KEY = 'Tabs';
const TAB_MODS = [Overview, Environmental, Social, Governance];

/**
 * @param {Object} tabsContent - tabs content from CMS to be modified
 * @param {Object[]} tabMods - collection of modifications that match CMS tabs and their sections
 * @return {Object} clone of tabs content modified by matching tabMods
 */
const modifyTabs = (tabsContent, tabMods) => {
  if (!tabsContent) return null;

  const content = cloneDeep(tabsContent);

  const tabs = content.fields.tabItems.map((tab) => {
    const { key } = tab.fields;
    const tabMod = find(tabMods, { key });

    if (!tabMod) return tab;

    const sectionMods = tabMod.content;

    const sections = tab.fields.content.map((section) => {
      const fullTitle = section.fields.entryTitle || section.fields.title || '';
      const title = fullTitle.split('> ').pop();
      const sectionMod = find(sectionMods, { key: title });

      if (!sectionMod) return section;

      section.fields = {
        ...section.fields,
        ...sectionMod,
      };

      return section;
    });

    tab.fields.content = sections;
    return tab;
  });

  content.fields.tabItems = tabs;
  return content;
};

const Tabs = ({ content }) => <Content data={modifyTabs(content, TAB_MODS)} />;

Tabs.propTypes = {
  content: PropTypes.object,
};

export default withContent(CONTENT_KEY)(Tabs);
